import { Component, Prop, Event, EventEmitter, Method, State, Element, h } from '@stencil/core';
import { Color, Size } from '../../interface';

@Component({
  tag: 'lar-debug',
  styleUrl: 'debug.scss',
  shadow: true
})
export class Debug {
  @Element() el!: HTMLLarDebugElement;

  /////// LarvaNode base properties
  /**
   * Component main icon
   */
  @Prop({ mutable: true }) icon?: string = 'security';
  /**
   * The color to use from your application's color palette.
   * Detrouble options are: `"primary"`, `"secondary"`, `"tertiary"`, `"success"`, `"warning"`, `"danger"`, `"light"`, `"medium"`, and `"dark"`.
   */
  @Prop({ mutable: true }) color?: Color = 'primary';
  /**
   * The color to use from your application's color palette for Components modal window.
   */
  @Prop({ mutable: true }) colorModal?: Color;
  /**
   * The color to use from your application's color palette for inputs
   */
  @Prop({ mutable: true }) colorInputs?: Color;
  /**
   * The color to use from your application's color palette for indication icon
   */
  @Prop() colorIconSmall?: Color;
  /**
   * Hide node titles
   */
  @Prop() hideTitles?: boolean;
  /**
   * Component superscript title
   */
  @Prop() supTitle?: string;
  /**
   * Component subtitle
   */
  @Prop() subTitle?: string;
  /**
   * Is logging for this component enabled (lar-log subcomponent loaded)
   */
  @Prop() log: boolean = false;
  /**
   * Node size
   */
  @Prop() nodeSize?: Size = 'default';
  /**
   * Component main title
   */
  @Prop() mainTitle!: string;
  /**
   * @see {@link ../readme.md} chapter "Components input and output" for further information.
   */
  @Event() output!: EventEmitter;
  /**
   * @see {@link ../readme.md} chapter "Sub-Components requests and responses" for further information.
   */
  @Event() request!: EventEmitter;
  private readInterval?: number;
  /////// LarvaNode base properties and events - end

  @State() text: any;
  @State() loading: boolean = true;

  private node!: HTMLLarNodeElement;

  componentDidLoad() {
    const el = this.el.shadowRoot || this.el;
    this.node = el.querySelector('lar-node') as HTMLLarNodeElement;
    this.output.emit();
    this.readInterval = window.setInterval(() => {
      this.loading = true;
      this.output.emit(); // send read again
    }, 5000);
  }
  /**
   * Larva error input
   */
  @Method()
  async error(data: any) {
    if (this.node) {
      this.node.error(data);
    }
    this.clearReadInterval();
    this.loading = false;
  }
  /**
   * Input Larva event message (see abow)
   */
  @Method()
  async input(data: any) {
    this.clearReadInterval();
    this.loading = false;
    this.text = data;
  }

  clearReadInterval() {
    if (this.readInterval !== undefined) {
      clearInterval(this.readInterval);
      this.readInterval = undefined;
    }
  }

  render() {
    const compnentProps = {
      text: this.text
    };
    return [
      <lar-node
        icon={this.icon}
        hideTitles={this.hideTitles}
        color={this.color}
        supTitle={this.supTitle}
        mainTitle={this.mainTitle}
        subTitle={this.subTitle}
        colorModal={this.colorModal}
        colorInputs={this.colorInputs}
        colorIconSmall={this.colorIconSmall}
        nodeSize={this.nodeSize}
        log={this.log}
        loading={this.loading}
        component="lar-debug-content"
        componentProps={compnentProps}
      >
        <slot />
      </lar-node>
    ];
  }
}
